/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import styles from './styles/LoginOTPSection.styles';
import { isCanada } from '../../../../../../../utils';
import LoginHeader from '../../../molecules/LoginHeader';
import LoginOTPForm from '../../../molecules/LoginOTPForm';
import LoginOTPFormV2 from '../../../molecules/LoginOTPFormV2';
import Anchor from '../../../../../../common/atoms/Anchor';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblLoginNot,
} from '../../../../../../../utils/labels/globalLogin.labels';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_HELPCENTER_LABELS,
  GlobalHelpCenterLabels,
  lblMergeResendOtp,
} from '../../../../../../../utils/labels/globalHelpCenter.labels';
import GlobalAccountDrawerLabels, {
  GLOBAL_ACCOUNT_DRAWER_LABELS,
  lblAccountDrawerLogout,
} from '../../../../../../../utils/labels/globalAccountDrawer.labels';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblCreditCard,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import {
  GlobalAccessibilityLabels,
  GLOBAL_ACCESSIBILITY_LABELS,
  myPlaceRewards,
} from '../../../../../../../utils/labels/globalAccessibility.labels';

const LogOutPageContainer = dynamic(() =>
  // eslint-disable-next-line extra-rules/no-commented-out-code
  import(/* webpackChunkName: "logout-page" */ '../../../../Logout/container/LogOut.container')
);

class LoginOTPSection extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isCanada = isCanada();
    this.state = {
      newCodeSent: false,
    };
    this.loginLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);
  }

  onOTPVerify = (values) => {
    const { onSubmit, emailAddress, rememberUser } = this.props;
    const payload = { ...values, emailAddress, rememberMe: rememberUser };
    onSubmit(payload);
  };

  generateOTP = (payload) => {
    const { onGenerateOTP, otpMessageThreshold, loginErrorMessage, trackAnalyticsClick } =
      this.props;
    onGenerateOTP({ isResend: true, ...payload });
    if (!loginErrorMessage && loginErrorMessage === '') {
      this.setState({ newCodeSent: true });
    }
    const timer = setTimeout(() => {
      this.setState({ newCodeSent: false });
      clearTimeout(timer);
    }, otpMessageThreshold);

    trackAnalyticsClick({
      metric33: '1',
      eVar150: getLabelFromCopyOrFromTranslation(
        `${GLOBAL_HELPCENTER_LABELS}.${lblMergeResendOtp}`,
        GlobalHelpCenterLabels
      ),
      customEvents: ['event33'],
    });
  };

  static contextType = LabelsContext;

  getSignOutSection = (
    { isRememberedUser, logoutlabels, userName },
    isV2Flow,
    isNewLoginScreen,
    fromPlccICLogin
  ) => {
    const logoutLabel = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_ACCOUNT_DRAWER_LABELS}.${lblAccountDrawerLogout}`,
      GlobalAccountDrawerLabels
    );
    return isRememberedUser ? (
      <BodyCopy component="div" className="elem-pb-XXS">
        <BodyCopy
          fontFamily="primary"
          fontSize="fs14"
          textAlign={'left'}
          fontWeight={isNewLoginScreen && isRememberedUser ? 'semibold' : 'normal'}
        >
          {`${this.loginLabels[lblLoginNot]} ${fromPlccICLogin ? 'You' : userName}? `}
          <Anchor
            underline
            fontSizeVariation="medium"
            anchorVariation="primary"
            onClick={this.showLoginForm}
          >
            <LogOutPageContainer
              labels={logoutlabels}
              underline
              isV2Flow={isV2Flow}
              logoutLabel={logoutLabel}
              isLoginFlow={true}
              fromPlccICLogin={fromPlccICLogin}
            />
          </Anchor>
        </BodyCopy>
      </BodyCopy>
    ) : null;
  };

  renderPLCCsubHeaderText = () => {
    const headerLabel = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_ACCESSIBILITY_LABELS}.${myPlaceRewards}`,
      GlobalAccessibilityLabels
    )?.split(' ');
    return (
      <BodyCopy className="plcc-text elem-mt-XL_1" textAlign="left">
        <BodyCopy component="span" fontWeight="medium" fontSize="fs16" fontFamily="secondary">
          {`${getDynamicLabelValues('dynamic.cart.lbl_plcc_ic_login_modal_subheader')} `}
        </BodyCopy>
        <span>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs16"
            className="text-style-1"
            fontFamily="secondary"
          >
            {headerLabel[0] ? `${headerLabel[0]} ` : ''}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs16"
            className="text-style-2"
            fontFamily="secondary"
          >
            {headerLabel[1] ? `${headerLabel[1]} ` : ''}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs16"
            className="text-style-3"
            fontFamily="secondary"
          >
            {headerLabel[2] ? `${headerLabel[2]} ` : ''}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs16"
            className="text-style-4"
            fontFamily="secondary"
          >
            {getLabelFromCopyOrFromTranslation(
              `${GLOBAL_GENERIC_LABELS}.${lblCreditCard}`,
              GlobalGenericLabels
            )}
          </BodyCopy>
        </span>
      </BodyCopy>
    );
  };

  getHeaderContent = () => {
    const { isV2Flow, isNewLoginScreen, fromPlccICLogin, isRememberedUser, rememberedEmail } =
      this.props;
    return (
      <div>
        <BodyCopy
          textAlign={fromPlccICLogin ? 'left' : 'center'}
          fontSize={isNewLoginScreen ? 'fs14' : 'fs13'}
          fontFamily="secondary"
          component="div"
          className={isNewLoginScreen && isRememberedUser ? 'elem-mt-XL' : ''}
        >
          {rememberedEmail}
        </BodyCopy>
        {this.getSignOutSection(this.props, isV2Flow, isNewLoginScreen, fromPlccICLogin)}
        {this.renderPLCCsubHeaderText()}
      </div>
    );
  };

  render() {
    const { newCodeSent } = this.state;
    const otpSectionProps = {
      ...this.props,
      newCodeSent,
      onSubmit: this.onOTPVerify,
      generateOTP: this.generateOTP,
    };
    const {
      className,
      fullPage,
      variation,
      isV2Flow,
      maskedPhoneNumber,
      backToBag,
      isLoginWithOTPEnabled,
      loginSelectedOption,
      emailAddress,
      fromPlccICLogin,
      userName,
      isPlccLoginLoading,
    } = this.props;
    const { extraConfig } = this.context;
    const { isNewLoginScreen: isNewLoginScreenExtraConfig } = extraConfig || {};
    const isNewLoginScreen = fromPlccICLogin ? true : isNewLoginScreenExtraConfig;
    const LoginOTPFormComp = isNewLoginScreen ? LoginOTPFormV2 : LoginOTPForm;

    const {
      lbl_login_v2_verification_code_sent: lblLoginV2VerificationCodeSent,
      lbl_login_verification_code: lblLoginVerificationCode,
      lbl_login_back_to_bag_label: lblLoginBackToBag,
    } = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);

    const { lbl_login_checkout_modal_heading: lblLoginCheckoutModalHeading } =
      getDynamicLabelValues('dynamic.account_d');
    const loginPlccHeaderLabel = `${lblLoginCheckoutModalHeading?.replace('!', '')} ${userName}!`;
    const otpLoginHeader = isNewLoginScreen
      ? lblLoginV2VerificationCodeSent
      : lblLoginVerificationCode;
    return (
      <div className={className}>
        <React.Fragment>
          <LoginHeader
            className={className}
            isCanada={isCanada}
            variation={isV2Flow ? 'checkout' : variation}
            fullPage={fullPage}
            headingLabel={
              (fromPlccICLogin || isPlccLoginLoading) && userName
                ? loginPlccHeaderLabel
                : otpLoginHeader
            }
            maskedPhoneNumber={maskedPhoneNumber}
            isLoginWithOTPEnabled={isLoginWithOTPEnabled}
            loginSelectedOption={loginSelectedOption}
            emailAddress={emailAddress}
            fromPlccICLogin={fromPlccICLogin}
          />
          {fromPlccICLogin && this.getHeaderContent()}
          <BodyCopy
            component="div"
            textAlign="center"
            className={
              isNewLoginScreen ? (fromPlccICLogin ? 'elem-mt-LRG' : 'elem-mt-XL_1') : 'underline'
            }
          />

          <BodyCopy component="div" textAlign="left">
            <LoginOTPFormComp {...otpSectionProps} isCanada={this.isCanada} />
          </BodyCopy>
          {isV2Flow && !isNewLoginScreen && (
            <BodyCopy component="div" textAlign="center" className="elem-mt-XXXL">
              <Anchor
                underline
                fontSizeVariation="large"
                fontSize="fs14"
                anchorVariation="primary"
                dataLocator="Back to Bag"
                onClick={backToBag}
                textAlign="center"
              >
                {lblLoginBackToBag}
              </Anchor>
            </BodyCopy>
          )}
        </React.Fragment>
      </div>
    );
  }
}

LoginOTPSection.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  variation: PropTypes.string,
  isV2Flow: PropTypes.bool,
  otpMessageThreshold: PropTypes.number,
  showRecaptcha: PropTypes.bool,
  loginErrorMessage: PropTypes.string,
  maskedPhoneNumber: PropTypes.string,
  isLoginWithOTPEnabled: PropTypes.bool,
  rememberUser: PropTypes.bool,
};

LoginOTPSection.defaultProps = {
  showRecaptcha: true,
  errorMessage: '',
  variation: '',
  isV2Flow: false,
  otpMessageThreshold: 5000,
  loginErrorMessage: '',
  maskedPhoneNumber: null,
  rememberUser: true,
};

export default withStyles(LoginOTPSection, styles);
export { LoginOTPSection as LoginOTPSectionVanilla };
